export const instance = {
  viu : "Viu",
  enterprise: "Enterprise"
};

export const agencycode = {
  viu: "CCC",
  wfp: "WFP",
  atm: "ATMP"
}

export const targets = {
  bp: "BP",
  epic: "EPIC"
}

export const integrateLinks = {
  bp: "IntegrateBP",
  epic: "IntegrateEpic"
}

export const bpoffice = {
  main: 21553
};
